<template>
    <div id="originality">
        <div class="ipt">主图：</div>
        <span class="btn btn-light border mr-2" style="margin-bottom: 10px;" @click="chooseImage">
            <i class="el-icon-plus"></i>
        </span>
        <div class="picture">
            <!--主图可以添加多个图片-->
            <div id="img" v-for="(imgsrc,index) in imgDatas" :key="index">
                    <img id="imgshow" :src="imgsrc" @mouseenter="enterImg(index)">
                    <div class="el-icon-error" @click="deleteMulPic(index)" style="cursor: pointer;
        position: absolute;
        width: 10px;
        height: 10px;
        margin-left: 93px;
        margin-top: -108px;"></div>
            </div>
        </div>
        <!-- <input id="filed" type="file" multiple="multiple" accept="image/*,application/pdf" style="display: none;"
            @change="changeMulPic()"> -->


    </div>
</template>

<script>
    export default {
        name: "originality",
        props: ["imgDatas"],
        components: {

        },
        data() {
            return {
                imgsrcs: []
            }
        },
        mounted() {
        },
        methods: {
            chooseImage() {
                this.$emit("chooseImage");
            },
            deleteMulPic(param) {
                this.$emit("deleteImage", param);
            },
            enterImg(index) {

            }
        }
    }
</script>

<style scoped>
    .Mainpicture {
        float: left;
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid #E5E9F2;
    }

    .picture {
        min-height: 100px;
    }

    .files {
        display: none;
        float: left;
    }

    #img {
        margin-right: 20px;
        margin-bottom: 30px;
        float: left;
        width: 100px;
        height: 100px;
        border-radius: 2px;
        border: 1px solid #E5E9F2;
    }

    .icon-cha {
        cursor: pointer;
        position: absolute;
        width: 10px;
        height: 10px;
        margin-left: 85px;
        margin-top: -100px;
        color: #BFC5D1;
    }

    #imgshow {
        width: 100px;
        height: 100px;
    }

    .icon-jia {
        text-align: center;
        width: 20px;
        height: 20px;
        line-height: 20px;
        color: #BFC5D1;
        padding: 40px;
        cursor: pointer;
    }
</style>